import styled from "styled-components";

export const ModalTitle = styled.h2`
  font-weight: 700;
  font-size: 18px;
  color: var(--header-ebony-color, var(--ebony));
  margin-bottom: 24px;
  line-height: 24px;
`;

export const ModelDescription = styled.p`
  font-weight: 400;
  font-size: 15px;
  color: var(--header-ebony-color, var(--ebony));
  line-height: 24px;
`;

export const Cost = styled(ModelDescription)`
  color: var(--header-slate-color, var(--slate));
  height: 20px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 56px;
  align-items: center;
`;

export const ObsButtonGroup = styled(ButtonGroup)`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin: 0;
  align-items: center;

  .learn-more {
    color: var(--color-text-neutral-default);
    &:hover {
      background: none;
    }
  }
`;

export const SellableTitle = styled.h3`
  font-weight: 700;
  font-size: 18px;
  margin: 0;
`;

export const SellableContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const ObsSellableContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const BannerWrapper = styled.div`
  margin-bottom: 16px;
  margin-left: -40px;
  margin-right: -40px;
  @media screen and (max-width: 767px) {
    margin-left: -24px;
    margin-right: -24px;
  }
`;
export const BannerContent = styled.div`
  margin-top: 32px;
`;
